import { render } from "./FiltersPreview.vue?vue&type=template&id=b008bd74&scoped=true"
import script from "./FiltersPreview.vue?vue&type=script&lang=js"
export * from "./FiltersPreview.vue?vue&type=script&lang=js"

import "./FiltersPreview.vue?vue&type=style&index=0&id=b008bd74&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b008bd74"]])

export default __exports__